import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'antd';
import * as ConstantsReserve from './../../constants/reserve';
import './styles.css';

const { Column, ColumnGroup } = Table;

const ReservationsByRestoTableAdmin = ({ data }) => {
    return (
        <Table className="reservationsByRestoAdminCont" dataSource={data} rowKey="id" size="small" pagination={false}>
            <Column title="Nombre del restaurante" dataIndex="restoName" key="restoName" align="center"/>
            <Column title="Total de personas" dataIndex="peopleTotalCount" key="peopleTotalCount" align="center" />
            <Column title="Cantidad de reservas" dataIndex="reservationCount" key="reservationCount" align="center" />
            <ColumnGroup title="Estado">
                <Column title="Pendientes" dataIndex={ConstantsReserve.RESERVE_STATE.pending} key={ConstantsReserve.RESERVE_STATE.pending} align="center" />
                <Column title="Aceptadas" dataIndex={ConstantsReserve.RESERVE_STATE.accepted} key={ConstantsReserve.RESERVE_STATE.accepted} align="center" />
                <Column title="Canceladas" dataIndex={ConstantsReserve.RESERVE_STATE.cancelled} key={ConstantsReserve.RESERVE_STATE.cancelled} align="center" />
                <Column title="Rechazadas" dataIndex={ConstantsReserve.RESERVE_STATE.rejected} key={ConstantsReserve.RESERVE_STATE.rejected} align="center" />
                <Column title="Asistidas" dataIndex={ConstantsReserve.RESERVE_STATE.assisted} key={ConstantsReserve.RESERVE_STATE.assisted} align="center" />
                <Column title="No asistidas" dataIndex={ConstantsReserve.RESERVE_STATE.no_assisted} key={ConstantsReserve.RESERVE_STATE.no_assisted} align="center" />
            </ColumnGroup>
        </Table>
    );
};

ReservationsByRestoTableAdmin.propTypes = {
    data: PropTypes.array.isRequired,
};

export default ReservationsByRestoTableAdmin;